import { replayAnimation } from "../../lib/motion"

// Product Form Navigation Module - 스텝 네비게이션 및 UI 업데이트
// 메인 product_form_controller.js에서 import하여 사용

export const NavigationMixin = {
  nextStep() {
    if (this.currentStepValue < 3) {
      this.currentStepValue++
      this.updateUI()
    }
  },

  prevStep() {
    if (this.currentStepValue > 1) {
      this.currentStepValue--
      this.updateUI()
    }
  },

  updateUI() {
    // Step visibility — the incoming step slides in from the side you're travelling to.
    const direction = this.shownStep && this.currentStepValue < this.shownStep ? "back" : "forward"
    const changed = this.shownStep !== undefined && this.shownStep !== this.currentStepValue
    this.stepTargets.forEach((step) => {
      const stepNumber = parseInt(step.dataset.step, 10)
      if (stepNumber === this.currentStepValue) {
        step.classList.remove("hidden")
        if (changed) replayAnimation(step, `wizard-step-in-${direction}`)
      } else {
        step.classList.add("hidden")
      }
    })
    this.shownStep = this.currentStepValue

    // 전체 진행률 계산
    const totalSteps = 3
    const currentStep = this.currentStepValue
    const progressPercent = ((currentStep - 1) / (totalSteps - 1)) * 100

    // 프로그레스바 업데이트
    const progressBar = document.querySelector('.progress-bar-fill')
    if (progressBar) {
      progressBar.style.setProperty('--progress', `${progressPercent}%`)
      progressBar.setAttribute('aria-valuenow', progressPercent)
    }

    // 스텝 마커 상태 업데이트
    const stepMarkers = document.querySelectorAll('.step-marker')
    stepMarkers.forEach((marker, idx) => {
      const stepNum = idx + 1
      marker.classList.remove('is-pending', 'is-active', 'is-complete')

      if (stepNum < currentStep) {
        marker.classList.add('is-complete')
      } else if (stepNum === currentStep) {
        marker.classList.add('is-active')
      } else {
        marker.classList.add('is-pending')
      }
    })

    // Button visibility
    const isFirstStep = this.currentStepValue === 1
    const isLastStep = this.currentStepValue === 3

    if (this.hasCancelButtonTarget) this.toggleButtonVisibility(this.cancelButtonTarget, isFirstStep)
    if (this.hasPrevButtonTarget) this.toggleButtonVisibility(this.prevButtonTarget, !isFirstStep)
    if (this.hasNextButtonTarget) this.toggleButtonVisibility(this.nextButtonTarget, !isLastStep)
    if (this.hasSubmitButtonTarget) this.toggleButtonVisibility(this.submitButtonTarget, isLastStep)

    // Scroll to section top for better UX
    this.scrollToSection(this.currentStepValue)
  },

  toggleButtonVisibility(button, shouldShow) {
    if (!button) return

    if (shouldShow) {
      button.classList.remove('hidden')
      button.classList.add('animate-fade-in')
      // Remove animation class after duration (BusinessConstants::UITiming::ANIMATION_DURATION_SHORT_MS)
      window.setTimeout(() => button.classList.remove('animate-fade-in'), window.BusinessConstants.UITiming.ANIMATION_DURATION_SHORT_MS)
    } else {
      button.classList.add('hidden')
    }
  },

  // Scroll to section top on step change
  // Ensures user always sees the beginning of each step for better UX
  scrollToSection(stepNumber) {
    // Find the section for the current step
    const section = this.stepTargets.find(
      step => parseInt(step.dataset.step, 10) === stepNumber
    )

    if (!section) return

    // Calculate header offset dynamically (handles sticky header)
    const header = document.querySelector('header')
    const headerOffset = header ? header.offsetHeight : 80

    // Calculate scroll position (section top minus header height)
    const sectionTop = section.getBoundingClientRect().top + window.pageYOffset - headerOffset

    // Smooth scroll to section top
    window.scrollTo({
      top: sectionTop,
      behavior: 'smooth'
    })
  }
}
